import React from 'react';
import Chip from '@mui/material/Chip';
import { useTheme, alpha } from '@mui/material/styles';

interface LabelChipProps {
  label: string;
  color?: string;
}

const LabelChip: React.FC<LabelChipProps> = ({
  label,
  color,
}) => {
  const theme = useTheme();

  const textColor = color || theme.palette.secondary.main;
  const bgColor = alpha(textColor, 0.1);

  return (
    <Chip
      label={label}
      sx={{
        backgroundColor: bgColor,
        color: textColor,
        cursor: 'pointer',
        fontSize: '10px',
        fontWeight: 900,
        padding: '2px 12px',
        height: 'auto',
        borderRadius: '100px',
        marginLeft: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        verticalAlign: 'baseline',
        '& .MuiChip-label': {
          padding: 0,
        },
        'aria-label': label,
      }}
    />
  );
};

export default LabelChip;
